module.exports = __webpack_public_path__ + "media/images/flags/16/Romania-2efc19f36a3dc8a2a7eca3a16fb71e97.png";